import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { AuthContext } from '../../../context/AuthProvider';
import { toast } from 'react-hot-toast';
import Dashboard from './../../Dashboard/Dashboard';

const Navbar = () => {
    const { user, userlogOut } = useContext(AuthContext)
    const handleSignOut = () => {
        userlogOut()
            .then(result => {

            })
            .catch(error => {
                console.log(error.message)
            })
    }
    return (
        <div className="navbar bg-base-100">
            <div className="navbar-start">
                <div className="dropdown">
                    <label tabIndex={0} className="btn btn-ghost lg:hidden">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h8m-8 6h16" /></svg>
                    </label>
                    <ul tabIndex={0} className="menu menu-compact dropdown-content mt-3 p-2 shadow bg-base-100 rounded-box w-52">
                        <li><Link to='/'>Home</Link></li>
                        <li><Link to='/mainappointment'>Appointment</Link></li>
                        <li><Link to='/contactus'>Contactus</Link></li>
                        <li>
                           <Link to='/dashboard'>Dashboard</Link>
                        </li>

                        <li><Link to='/login'>Login</Link></li>
                        <li><Link to='/register'>Register</Link></li>
                    </ul>
                </div>
                <Link to='/'>DentistCare</Link>
            </div>
            <div className="navbar-center hidden lg:flex">
                <ul className="menu menu-horizontal px-1">
                    <li><Link to='/'>Home</Link></li>
                    <li><Link to='/mainappointment'>Appointment</Link></li>
                    <li><Link to='/contactus'>Contactus</Link></li>
                    <li>
                    <li>
                           <Link to='/dashboard'>Dashboard</Link>
                        </li>
                       
                    </li>
                    <li><Link to='/login'>Login</Link></li>
                    <li><Link to='/register'>Register</Link></li>

                </ul>
            </div>
            <label htmlFor="dashboard-drawer"  tabIndex={2} className="btn btn-ghost lg:hidden">
                <svg  xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h8m-8 6h16" /></svg>
            </label>
            <div className="navbar-end">
                {
                    user?.uid ?

                        <button className='text-red-700 font-bold btn btn-outline' onClick={handleSignOut}>logout</button> :
                        <Link to='/login'><button className='text-info font-bold btn btn-outline'>login</button></Link>
                }

            </div>

        </div>
    );
};

export default Navbar;